import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {CommonTransformationService} from "@app/shared/services/common-transformation.service";
import {SelectItem} from "primeng/api";
import {PayrollWageDetermination} from "@app/payroll/payroll";
import {Simulate} from "react-dom/test-utils";
import drop = Simulate.drop;

@Injectable({
  providedIn: 'root'
})
export class WageDeterminationService {

  constructor(private http: HttpClient, private transform: CommonTransformationService) {
  }

  getWageDeterminationNumbers(): Observable<any> {
    const url = `/payroll/wage-determinations/wd-numbers`;

    return this.http.get<any>(url);
  }

  getWageDeterminationNumbersAsDropdown(): Observable<SelectItem[]> {
    return this.getWageDeterminationNumbers().pipe(map(res => {
      let dropdown = this.transform.convertToDropDown("wdNumber", res, "id");
      for (let wdNumber of dropdown) {  // backend returns string value of id
        wdNumber.value = Number(wdNumber.value);
      }
      return dropdown;
    }));
  }

  getWageDeterminationById(wageDeterminationId: number): Observable<PayrollWageDetermination> {
    let url = `/payroll/wage-determinations/${wageDeterminationId}`;
    return this.http.get<PayrollWageDetermination>(url);
  }
}
